import React from "react";
import { Link } from "react-router-dom";

// Simple icon components (using Heroicons style)
const IconComputer = () => (
    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9.75 17L9 20.25 15 20.25 14.25 17m-5.25 0h6m-6 0a3 3 0 01-3-3v-7.5a3 3 0 013-3h7.5a3 3 0 013 3V14a3 3 0 01-3 3H9z" />
    </svg>
);

const IconTarget = () => (
    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M16.5 10.5a6 6 0 11-12 0 6 6 0 0112 0zM19.5 19.5L15 15" />
    </svg>
);

const IconFunnel = () => (
    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 3c4.97 0 9 1.507 9 3.364 0 1.858-4.03 3.364-9 3.364S3 8.222 3 6.364 7.03 3 12 3zM3 9.75v5.886c0 1.858 4.03 3.364 9 3.364s9-1.506 9-3.364V9.75M3 15.636v2.25c0 1.858 4.03 3.364 9 3.364s9-1.506 9-3.364v-2.25" />
    </svg>
);

const IconSearch = () => (
    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
    </svg>
);

const IconSpeed = () => (
    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
    </svg>
);

const IconSupport = () => (
    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
);

const IconCheck = () => (
    <svg className="w-5 h-5 text-indigo-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
    </svg>
);

export default function Uniproid() {
    const features = [
        { name: "Authority Website", icon: <IconComputer />, desc: "Custom-designed site that builds credibility instantly." },
        { name: "Strategic Positioning", icon: <IconTarget />, desc: "Messaging that resonates with your ideal clients." },
        { name: "Lead Generation Setup", icon: <IconFunnel />, desc: "Forms & CTAs to capture opportunities 24/7." },
        { name: "SEO Ready Structure", icon: <IconSearch />, desc: "Optimized to be found when it matters most." },
        { name: "Performance Optimization", icon: <IconSpeed />, desc: "Lightning fast & flawless on every device." },
        { name: "Continuous Support", icon: <IconSupport />, desc: "Dedicated team ensuring your identity evolves." },
    ];

    return (
        <div className="bg-white text-gray-900 font-sans antialiased overflow-x-hidden">



            {/* HERO SECTION */}
            <section className="relative min-h-screen flex items-center justify-center text-center px-6 overflow-hidden bg-gradient-to-br from-indigo-50 via-white to-purple-50">
                {/* Abstract decorative blobs */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
                    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
                </div>
                <div className="relative max-w-5xl mx-auto">
                    <h1 className="text-5xl md:text-7xl font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-900">
                        Digital Identity Infrastructure
                        <br /> for Modern Professionals
                    </h1>
                    <p className="mt-8 text-xl text-gray-700 max-w-3xl mx-auto">
                        Uniproid builds your professional authority online —
                        so clients trust you before the first conversation.
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/free-trial"
                            className="px-10 py-5 bg-gray-900 text-white text-lg font-semibold rounded-2xl hover:bg-gray-800 transition shadow-2xl hover:shadow-indigo-200/50 transform hover:scale-105 inline-block text-center"
                        >
                            Start 30-Day Free Experience
                        </Link>

                    </div>
                    <p className="mt-8 text-sm text-gray-500">No credit card required · Cancel anytime</p>
                </div>
            </section>

            {/* PROBLEM */}
            <section className="py-28 bg-white px-6">
                <div className="max-w-6xl mx-auto text-center">
                    <span className="inline-block px-4 py-1 bg-red-100 text-red-700 rounded-full text-sm font-semibold tracking-wide">The Challenge</span>
                    <h2 className="mt-6 text-4xl md:text-5xl font-bold">
                        Professionals Are Judged Online First
                    </h2>
                    <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
                        Before meetings, partnerships, or investments — people search your name online.
                        A weak digital presence leads to lost trust and missed opportunities.
                    </p>
                    <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
                        <div className="p-6 bg-gray-50 rounded-3xl border border-gray-100 shadow-sm">
                            <div className="w-12 h-12 bg-red-100 rounded-2xl flex items-center justify-center text-2xl mb-4">🔍</div>
                            <h3 className="text-xl font-semibold">First impressions are digital</h3>
                            <p className="mt-2 text-gray-600">93% of hiring managers search candidates online before making a decision.</p>
                        </div>
                        <div className="p-6 bg-gray-50 rounded-3xl border border-gray-100 shadow-sm">
                            <div className="w-12 h-12 bg-red-100 rounded-2xl flex items-center justify-center text-2xl mb-4">⏳</div>
                            <h3 className="text-xl font-semibold">Trust takes seconds to break</h3>
                            <p className="mt-2 text-gray-600">An outdated profile can undo years of reputation building.</p>
                        </div>
                        <div className="p-6 bg-gray-50 rounded-3xl border border-gray-100 shadow-sm">
                            <div className="w-12 h-12 bg-red-100 rounded-2xl flex items-center justify-center text-2xl mb-4">💼</div>
                            <h3 className="text-xl font-semibold">Opportunity cost is real</h3>
                            <p className="mt-2 text-gray-600">Invisible professionals lose up to 40% of potential leads.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* SOLUTION */}
            <section className="py-28 bg-gray-50 px-6">
                <div className="max-w-6xl mx-auto text-center">
                    <span className="inline-block px-4 py-1 bg-indigo-100 text-indigo-700 rounded-full text-sm font-semibold tracking-wide">The Uniproid Way</span>
                    <h2 className="mt-6 text-4xl md:text-5xl font-bold">
                        Meet Uniproid
                    </h2>
                    <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
                        A complete Digital Identity Platform designed to position founders, executives,
                        and consultants as trusted authorities.
                    </p>
                    <div className="mt-16 flex flex-col lg:flex-row items-center gap-12">
                        <div className="lg:w-1/2 text-left space-y-6">
                            <div className="flex items-start gap-4">
                                <IconCheck />
                                <div>
                                    <h4 className="text-xl font-semibold">Enterprise-grade infrastructure</h4>
                                    <p className="text-gray-600">Dedicated servers, global CDN, and bank-level security out of the box.</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-4">
                                <IconCheck />
                                <div>
                                    <h4 className="text-xl font-semibold">Strategic narrative design</h4>
                                    <p className="text-gray-600">We craft your story to attract the right audience and opportunities.</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-4">
                                <IconCheck />
                                <div>
                                    <h4 className="text-xl font-semibold">Done-for-you maintenance</h4>
                                    <p className="text-gray-600">Your identity stays fresh, fast, and secure — always.</p>
                                </div>
                            </div>
                        </div>
                        <div className="lg:w-1/2 bg-gradient-to-br from-indigo-500 to-purple-600 p-1 rounded-3xl shadow-2xl">
                            <div className="bg-white rounded-3xl p-8 text-left">
                                <div className="text-3xl mb-4">✨</div>
                                <h5 className="text-2xl font-bold">Your authority, amplified</h5>
                                <p className="mt-2 text-gray-600">Uniproid combines premium design with technical excellence so you can focus on your work.</p>
                                <div className="mt-6 flex items-center gap-2 text-indigo-600 font-medium">
                                    <span>Trusted by industry leaders</span>
                                    <span>→</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FEATURES */}
            <section className="py-28 bg-white px-6">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center">
                        <span className="inline-block px-4 py-1 bg-indigo-100 text-indigo-700 rounded-full text-sm font-semibold tracking-wide">Everything you need</span>
                        <h2 className="mt-6 text-4xl md:text-5xl font-bold">
                            A complete identity suite
                        </h2>
                        <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
                            From code to content — we handle the heavy lifting.
                        </p>
                    </div>
                    <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {features.map((feature, idx) => (
                            <div
                                key={idx}
                                className="group p-8 bg-white border border-gray-100 rounded-3xl shadow-md hover:shadow-2xl hover:border-indigo-100 transition-all duration-300 hover:-translate-y-2"
                            >
                                <div className="w-14 h-14 bg-indigo-50 rounded-2xl flex items-center justify-center group-hover:bg-indigo-100 transition">
                                    {feature.icon}
                                </div>
                                <h3 className="mt-6 text-2xl font-semibold">{feature.name}</h3>
                                <p className="mt-2 text-gray-600 leading-relaxed">{feature.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* INFRASTRUCTURE */}
            <section className="py-28 bg-gray-900 text-white px-6">
                <div className="max-w-6xl mx-auto text-center">
                    <h2 className="text-4xl md:text-5xl font-bold">
                        Enterprise-Level Infrastructure Included
                    </h2>
                    <p className="mt-6 text-xl text-gray-300 max-w-3xl mx-auto">
                        No shared hosting. No compromises. Every identity runs on dedicated resources.
                    </p>
                    <div className="mt-16 flex flex-wrap justify-center gap-4">
                        {["Dedicated Server", "2 Core CPU", "8GB RAM", "Global CDN", "24/7 Security", "Daily Backups"].map((item, i) => (
                            <span key={i} className="px-6 py-3 bg-gray-800 text-white rounded-full text-sm font-medium border border-gray-700 shadow-lg">
                                {item}
                            </span>
                        ))}
                    </div>
                    <p className="mt-12 text-2xl font-light text-indigo-300">
                        ⚡ 1 Year Free Support & Maintenance Included
                    </p>
                </div>
            </section>

            {/* PRICING */}
            <section className="py-28 bg-white px-6">
                <div className="max-w-6xl mx-auto text-center">
                    <span className="inline-block px-4 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold tracking-wide">Simple pricing</span>
                    <h2 className="mt-6 text-4xl md:text-5xl font-bold">
                        One Identity. One Powerful Plan.
                    </h2>
                    <p className="mt-4 text-xl text-gray-600">Everything included, no hidden fees.</p>
                    <div className="mt-16 max-w-lg mx-auto relative">
                        {/* Popular badge */}
                        <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-indigo-600 text-white px-6 py-1 rounded-full text-sm font-semibold shadow-lg">
                            Most popular
                        </div>
                        <div className="bg-white border-2 border-indigo-100 rounded-3xl p-10 shadow-2xl hover:shadow-indigo-200 transition">
                            <h3 className="text-3xl font-bold">Uniproid Digital Identity</h3>
                            <p className="mt-4 text-gray-600 text-lg">30-Day Free Experience</p>
                            <p className="mt-8 text-6xl font-extrabold">
                                $249<span className="text-2xl text-gray-500">/mo</span>
                            </p>
                            <p className="mt-2 text-gray-500">or $2,499 yearly (save 16%)</p>
                            <ul className="mt-8 space-y-4 text-left">
                                {["Authority website + hosting", "Strategic positioning workshop", "Lead capture setup", "SEO foundation", "Priority support"].map((item, i) => (
                                    <li key={i} className="flex items-center gap-3">
                                        <IconCheck />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                            <button className="mt-10 w-full bg-gray-900 text-white py-4 rounded-2xl text-lg font-semibold hover:bg-gray-800 transition shadow-xl hover:shadow-gray-400/30">
                                Start Free 30-Day Experience
                            </button>
                            <p className="mt-4 text-sm text-gray-400">No credit card required</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="py-28 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 text-white px-6 relative overflow-hidden">
                <div className="absolute inset-0 bg-black opacity-10"></div>
                <div className="relative max-w-4xl mx-auto text-center">
                    <h2 className="text-5xl md:text-6xl font-extrabold leading-tight">
                        Trust Begins Before Conversation
                    </h2>
                    <p className="mt-8 text-xl text-indigo-100 max-w-2xl mx-auto">
                        Join hundreds of professionals who turned their digital identity into their greatest asset.
                    </p>
                    <button className="mt-12 px-12 py-6 bg-white text-gray-900 text-xl font-semibold rounded-full hover:bg-gray-100 transition shadow-2xl transform hover:scale-105">
                        Launch Your Digital Identity
                    </button>
                    <p className="mt-8 text-indigo-200">30-day free trial · No commitment</p>
                </div>
            </section>

            {/* Simple Footer */}
            <footer className="py-12 bg-gray-50 text-gray-600 text-center">
                <p>© 2025 Uniproid. All rights reserved.</p>
            </footer>

            {/* Add custom keyframes for blob animation */}
            <style jsx>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
        </div>
    );
}